// extracted by mini-css-extract-plugin
export default {"errorPage":"errorBoundary_errorPage__T-fMp","icon":"errorBoundary_icon__xL03n","mainText":"errorBoundary_mainText__5p2Ox","subText":"errorBoundary_subText__7B1ed"};